import "@scss/pages/payment.scss";

import {
  $UserAddPermissions,
  ACTIONS,
  UserPriorityEnum,
} from "@store/user-store";
import { setTitle } from "@store/title-store";
import { TitleProps } from "@store/title-store";

import { TabItems } from "@components/common";
import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import {
  fetchAllTariffs,
  fetchPaymentHistory,
  fetchTariffPeriods,
} from "@store/payment-store";

import PaymentContent from "@pages/payment/payment-content";
import PaymentTariffEdit from "./paymant-edit";
import PaymentTariffManage from "./payment-tariffs-edit";
import PaymentTariffs from "@pages/payment/payment-tariffs";
import { useUnit } from "effector-react";

const Payment = () => {
  useEffect(() => {
    fetchTariffPeriods();
    // fetchCurrentTariff()
    fetchPaymentHistory({});
    fetchAllTariffs();
  }, []);

  const permissions = useUnit($UserAddPermissions);
  const { pathname } = useLocation();

  const canManageTariffs =
    permissions.hasRequiredLevel(UserPriorityEnum.Owner) ||
    permissions.hasPermission(ACTIONS.payment_tariffs_allowedToChange);

  const TAB_ITEMS: { label: string; path: string; exact?: boolean }[] = [
    // { label: 'Продление тарифа', path: '/payment', exact: true },
    // { label: 'История оплат', path: '/payment/history' },
    { label: "Тариф", path: "/payment/tariffs" },
  ];
  if (canManageTariffs) {
    TAB_ITEMS.push({ label: "Изменить тарифы", path: "/payment/manage" });
  }

  useEffect(() => {
    const newTitle = TAB_ITEMS.find((e) => pathname.indexOf(e.path) !== -1);

    const title = [
      { title: "Главная", href: "/" },
      { title: "Оплата", href: "/payment/tariffs" },
      { title: newTitle?.label, href: pathname },
    ] as TitleProps[];

    setTitle(title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <main className="content-container payment">
      <div className="content-section">
        {/* CONTENT */}
        <div className="tab-section">
          <div className="tab-cont">
            {/* TABS */}
            <TabItems items={TAB_ITEMS} />
            {/* TAB CONTENTS */}
            <div className="tab-content-items">
              <Routes>
                {/* FIRST TAB CONTENT */}
                <Route path="/" Component={PaymentContent} />
                {/* SECOND TAB CONTENT */}
                {/*<Route exact path='/payment/history' component={PaymentHistory} />*/}
                {/* THIRD TAB CONTENT */}
                <Route path="/tariffs" Component={PaymentTariffs} />
                {canManageTariffs && (
                  <>
                    <Route path="/tariffs/edit" Component={PaymentTariffEdit} />
                    <Route path="/manage" Component={PaymentTariffManage} />
                  </>
                )}
              </Routes>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Payment;
